/* SILQA-CARDADD 2026-07-31 河瀬さん指示:
   商品カテゴリ／検索結果の各カードに置いた「カートに追加」ボタンの動作。
   卸売りの発注では一覧から連続で入れるため、押した直後の手応えと連打耐性を優先している。

   設計:
   - 追加処理そのものは既存の共通関数 window.silqaCartAdd(variantId, btn) に委譲する。
     ドロワー表示・失敗時の巻き戻し・部品欠落時の自己復旧はすべて共通関数側に実装済みで、
     ここで再実装するとカート系の既知不具合（CLAUDE.md 罠5・13・18・19）を再発させる。
   - 共通関数は cart-drawer 経由で読み込まれる外部ファイル（defer）のため、
     ボタンが押された時点でまだ未定義のことがある。最大3秒待ってから実行する。
   - カード全体が <a> のリンクなので、ボタン押下がリンク遷移に化けないよう
     capture 段階で preventDefault / stopPropagation する。
*/
/* 押下フィードバック(SILQA-PRESS)は全ページで必要なため assets/silqa-cart-add.js 側に実装している */
(function () {
  if (window.__silqaCardAddInit) return;
  window.__silqaCardAddInit = true;

  var LABEL_BUSY = '追加中…';
  var LABEL_DONE = '追加しました';

  /* ラベルの中身はHTMLで持つ（「カートに」を別spanに分け、狭い端末ではCSSで隠して「追加」にしている）。
     textContentで書き換えるとその入れ子が消え、処理後に元のレイアウトへ戻せなくなるため、
     初回に元のHTMLを控えてからHTMLごと差し替える。 */
  function setLabel(btn, text) {
    var t = btn.querySelector('.silqa-cardadd__t');
    if (!t) return;
    if (btn.__silqaLabel == null) btn.__silqaLabel = t.innerHTML;
    if (text === null) t.innerHTML = btn.__silqaLabel;
    else t.textContent = text;
  }

  /* 共通関数の到着を待つ（deferで後から読み込まれるため） */
  function whenReady(cb, waited) {
    waited = waited || 0;
    if (typeof window.silqaCartAdd === 'function') return cb(true);
    if (waited >= 3000) return cb(false);
    setTimeout(function () { whenReady(cb, waited + 100); }, 100);
  }

  /* SILQA-SRC-20260815 河瀬さん指示: どの導線から追加されたかを注文データに残す。
     セット割ボックス(pdp)/ドロワーのおすすめ(cart)/一緒に使うと便利(card)は既に印を付けており、
     一覧からの直接追加だけが印なしで集計できなかった。
     アンダースコア始まりのプロパティはお客様には表示されない（カート・チェックアウトとも非表示）。 */
  function srcTag() {
    return location.pathname.indexOf('/search') === 0 ? 'search' : 'list';
  }

  function fallbackAdd(id) {
    /* 共通関数が来ない環境でも発注だけは通す。ドロワーは開かずカートページへ送る */
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: id, quantity: 1, properties: { _silqa_set: srcTag() } }] })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      window.location.href = '/cart';
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.silqa-cardadd') : null;
    if (!btn) return;
    /* カード全体のリンクへ伝播させない */
    e.preventDefault();
    e.stopPropagation();
    if (btn.disabled || btn.classList.contains('is-busy')) return;

    var id = btn.getAttribute('data-silqa-cardadd');
    if (!id) return;

    btn.classList.add('is-busy');
    setLabel(btn, LABEL_BUSY);

    var finish = function (ok) {
      btn.classList.remove('is-busy');
      if (ok) {
        btn.classList.add('is-done');
        setLabel(btn, LABEL_DONE);
        setTimeout(function () {
          btn.classList.remove('is-done');
          setLabel(btn, null);
        }, 1600);
      } else {
        setLabel(btn, null);
      }
    };

    /* SILQA 2026-10-21 予約受注: ボタンの data-silqa-props（JSON。例 {"お届け予定":"2026年11月上旬より順次発送予定（予約商品）"}）を
       行の属性として一緒に送る。予約商品のカート・チェックアウト・注文に引渡時期を残すため（snippets/silqa-card-add.liquid が出す） */
    var props = { _silqa_set: srcTag() };
    try {
      var extra = btn.getAttribute('data-silqa-props');
      if (extra) { var parsed = JSON.parse(extra); for (var k in parsed) { if (Object.prototype.hasOwnProperty.call(parsed, k)) props[k] = parsed[k]; } }
    } catch (err) {}

    whenReady(function (ready) {
      if (ready) {
        try {
          var p = window.silqaCartAdd(id, btn, props);
          if (p && typeof p.then === 'function') {
            p.then(function () { finish(true); }).catch(function () { finish(false); });
          } else {
            /* 戻り値が無い実装でも手応えは返す */
            setTimeout(function () { finish(true); }, 400);
          }
        } catch (err) { finish(false); }
      } else {
        fallbackAdd(id).catch(function () { finish(false); });
      }
    });
  }, true);
})();
